export default __webpack_public_path__ + "static/media/plus.a451a632.svg";